import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'react-modal';
import { ActionLink } from 'components/shared';
import apiClient from 'apiClient';
import Configuration from './Configuration';
import Share from './Share';
import CCEvents, { EventNames } from '@companycam/companycam-events';
import { Steven } from 'helpers/steven';

const GalleryModal = ({
  url,
  photoDatabaseIds,
  videoDatabaseIds,
  onRequestClose,
}) => {
  const [galleryId, setGalleryId] = useState(null);
  const [copied, setCopied] = useState(false);
  const [isSingleVideo, setIsSingleVideo] = useState(false);

  const logStevenEventShared = (receiver_type) => {
    Steven.entityShared({
      entity_type: isSingleVideo ? 'video' : 'photo_gallery',
      receiver_type,
      total_number_shared:
        (photoDatabaseIds?.length || 0) + (videoDatabaseIds?.length || 0),
      is_public: true,
      action: 'shared',
    });
  };

  const onSuccess = () => {
    setCopied(true);
    logStevenEventShared('copy_link');
  };

  const generateGallery = async (data) => {
    const params = { include_details: data.include_details || false };
    if (photoDatabaseIds && photoDatabaseIds.length) {
      params.images = photoDatabaseIds;
    }
    if (videoDatabaseIds && videoDatabaseIds.length) {
      params.videos = videoDatabaseIds;
    }
    const gallery = await apiClient.post(url, params);

    // Track gallery share
    CCEvents.logEvent(EventNames.SHARE_GALLERY);
    Steven.entityCrud({
      action: 'created',
      entity_type: 'photo_gallery',
      entity_id: `${gallery.id}`,
      source: null,
    });
    setGalleryId(gallery.token);
  };

  useEffect(() => {
    const checkIsSingleVideoGallery = () => {
      const isSingleVideoGallery =
        videoDatabaseIds &&
        videoDatabaseIds.length &&
        videoDatabaseIds.length === 1 &&
        !photoDatabaseIds;
      setIsSingleVideo(isSingleVideoGallery);
    };
    checkIsSingleVideoGallery();
  }, [videoDatabaseIds, photoDatabaseIds]);

  const headerDisplay = () => {
    return isSingleVideo ? (
      <FormattedMessage
        id="Videos.singleShareModal.shareVideo"
        defaultMessage="Share Gallery"
        description="section header"
      />
    ) : (
      <FormattedMessage
        id="Galleries.galleryModal.shareGallery"
        defaultMessage="Share Gallery"
        description="section header"
      />
    );
  };

  return (
    <Modal
      isOpen
      onRequestClose={onRequestClose}
      contentLabel="Share photos"
      overlayClassName="modal"
      className="modal-content-wrap"
    >
      <ActionLink className="modal-close-button" onClick={onRequestClose}>
        <i className="mdi mdi-close" />
      </ActionLink>
      <h3 className="modal-title">{headerDisplay()}</h3>
      {galleryId === null ? (
        <Configuration
          isSingleVideo={isSingleVideo}
          onSubmit={generateGallery}
        />
      ) : (
        <Share
          galleryId={galleryId}
          onSuccess={onSuccess}
          copied={copied}
          isSingleVideoGallery={isSingleVideo}
          onClickFacebook={() => logStevenEventShared('facebook')}
          onClickEmail={() => logStevenEventShared('email')}
        />
      )}
    </Modal>
  );
};

GalleryModal.propTypes = {
  url: PropTypes.string,
  photoDatabaseIds: PropTypes.arrayOf(PropTypes.number),
  videoDatabaseIds: PropTypes.arrayOf(PropTypes.number),
  onRequestClose: PropTypes.func,
};

GalleryModal.defaultProps = {
  url: 'image_galleries',
  photoDatabaseIds: null,
  videoDatabaseIds: null,
  onRequestClose: () => {},
};

export default GalleryModal;
